// src/components/Integrations/WhatsAppOAuthCallback.jsx
"use client";

import { useEffect } from 'react';
import Spinner from '../Spinner';

const WhatsAppOAuthCallback = () => {
  useEffect(() => {
    const handleOAuthCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        // Enviar error al parent window
        window.opener?.postMessage({
          type: 'OAUTH_ERROR',
          error: error
        }, window.location.origin);
        window.close();
        return;
      }

      if (code) {
        try {
          // Simular intercambio de código por datos reales
          // En producción, aquí harías la llamada real a tu backend
          console.log('Código recibido de Meta:', code);
          
          // Simular datos que recibirías de tu backend después del intercambio
          const simulatedBusinessData = {
            businessName: "Mi Empresa Demo",
            businessPhone: "+1 (555) 987-6543", 
            wabaId: "123456789012345",
            phoneNumberId: "987654321098765",
            accessToken: `real_token_from_code_${code.substring(0, 10)}`,
            businessId: "business_demo_12345",
            code: code // Incluir el código para referencia
          };

          // Enviar datos al parent window
          console.log('🚀 CALLBACK: Enviando datos al parent:', simulatedBusinessData);
          console.log('🚀 CALLBACK: Window opener exists:', !!window.opener);
          console.log('🚀 CALLBACK: Target origin:', window.location.origin);
          
          const messageData = {
            type: 'OAUTH_SUCCESS',
            ...simulatedBusinessData
          };
          
          console.log('🚀 CALLBACK: Message data:', messageData);
          
          window.opener?.postMessage(messageData, window.location.origin);

          // Dar un poco de tiempo para que el mensaje se procese
          setTimeout(() => {
            console.log('🚀 CALLBACK: Cerrando ventana...');
            window.close();
          }, 1000);

        } catch (error) {
          console.error('Error procesando OAuth:', error);
          window.opener?.postMessage({
            type: 'OAUTH_ERROR',
            error: error.message
          }, window.location.origin);
          
          setTimeout(() => {
            window.close();
          }, 1000);
        }
      } else {
        // No hay código ni error - algo salió mal
        window.opener?.postMessage({
          type: 'OAUTH_ERROR',
          error: 'No authorization code received'
        }, window.location.origin);
        
        setTimeout(() => {
          window.close();
        }, 1000);
      }
    };

    handleOAuthCallback();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center max-w-md">
        <div className="flex justify-center mb-4">
          <Spinner size="xl" color="green" />
        </div>
        <h2 className="text-white text-lg font-medium mb-2">✅ Autorización Exitosa</h2>
        <p className="text-gray-400 text-sm mb-4">
          WhatsApp Business ha sido autorizado correctamente.
        </p>
        <div className="bg-green-900/20 border border-green-700 rounded-lg p-3">
          <p className="text-green-200 text-sm">
            🔄 Configurando tu cuenta... Esta ventana se cerrará automáticamente.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppOAuthCallback;